'use strict';

const SoaModel = require('bunsen/models/SoaModel');
const endpoints = require('dibs-endpoints');

const RecommendationItem = SoaModel.extend({
    url() {
        return endpoints.recommendations('me');
    },

    getImage(imageName = 'small') {
        const images = this.get('images');

        if (images.length) {
            return images[0][imageName];
        }
    },

    getPdpUrl(urlId = 0) {
        const urls = this.get('pdpUrls');

        if (urls) {
            return urls[urlId];
        }
    },

    getTitle() {
        return this.get('title');
    }
});

module.exports = RecommendationItem;



// WEBPACK FOOTER //
// ./~/bunsen/models/identity/RecommendationItem.es.js